import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import Title from "../typography/Title";
import Subtitle from "../typography/Subtitle";
import { trackFunnelStep, trackLead } from "../../analytics/track";

const CalendlySection = () => {
  const date = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`

  // A booked slot is the strongest intent signal on the site — stronger than a
  // contact form — so it fires the same generate_lead event. Calendly runs in a
  // cross-origin iframe, so this postMessage listener is the only way to see it.
  useCalendlyEventListener({
    // Picked a time but not yet confirmed. Tracked to measure drop-off at the
    // final step; it is NOT a conversion and must not be imported into Ads.
    onDateAndTimeSelected: () => trackFunnelStep("demo_slot_selected", "calendly_demo"),
    onEventScheduled: () => trackLead("calendly_demo", "Book a Demo"),
  });
  return (
    <section
      id="book-demo"
      className="flex w-screen snap-start snap-always flex-col items-center justify-center gap-10 bg-gray-900 py-10 md:min-h-screen"
    >
      <div className="flex flex-col items-center justify-center gap-3 text-center">
        <Subtitle>Book a Demo</Subtitle>
        <Title>See Babblebots in Action</Title>
      </div>
      <div className="w-full max-w-screen-xl px-4 ">
        <InlineWidget
          url={`https://calendly.com/sales-babblebots/babblebots-discovery`}
          styles={{
            height: "700px",
            width: "100%",
          }}
          pageSettings={{
            backgroundColor: "111827",
            hideEventTypeDetails: false,
            hideLandingPageDetails: false,
            primaryColor: "FE7D4C",
            textColor: "67e8f9",
          }}
        />
      </div>
    </section>
  );
};

export default CalendlySection;
